import Repository from './repository'
import type Booking from '@/types/api/types/Booking'
import type CreditCard from '@/types/api/types/CreditCard'

export default {
  getBookings() {
    return Repository.get(`/v1/user/bookings`)
  },
  getBooking({ bookingNo }: { bookingNo: string }) {
    return Repository.get(`/v1/user/bookings/${bookingNo}`)
  },
  getPublicBooking({ bookingNo, lastName }: { bookingNo: string, lastName: string }) {
    return Repository.get<Booking>(`/v2/bookings/${bookingNo}?lastName=${lastName}`)
  },
  getEncryptedPublicBooking({ encryptedBookingNo, lastName }: { encryptedBookingNo: string | undefined, lastName: string | undefined }) {
    if (!encryptedBookingNo || !lastName) {
      return Promise.reject('Missing parameters')
    }
    return Repository.get<Booking>(`/v2/bookings/${encodeURIComponent(encryptedBookingNo)}?lastName=${lastName}&encrypted=true`)
  },
  postBookingCreditCard({ bookingNo, lastName, creditCardInfo }: { bookingNo: string, lastName: string, creditCardInfo: CreditCard }) {
    return Repository.post(`/v2/bookings/${bookingNo}/credit_cards?lastName=${lastName}`, { creditCardInfo })
  },
}
